import type { CustomerListParams } from '../api/customers-api';

/** Store-scoped keys: switching stores never shares cache. */
export const customerKeys = {
  all: (storeId: string) => ['stores', storeId, 'customers'] as const,
  lists: (storeId: string) => [...customerKeys.all(storeId), 'list'] as const,
  list: (storeId: string, params: CustomerListParams) =>
    [...customerKeys.lists(storeId), params] as const,
  details: (storeId: string) => [...customerKeys.all(storeId), 'detail'] as const,
  detail: (storeId: string, id: string) => [...customerKeys.details(storeId), id] as const,
  addresses: (storeId: string, id: string) =>
    [...customerKeys.detail(storeId, id), 'addresses'] as const,
  timeline: (storeId: string, id: string) =>
    [...customerKeys.detail(storeId, id), 'timeline'] as const,
};
